'use client';

import Icon from '@/components/ui/AppIcon';

export default function SpeakingEngagementForm() {
  const handleRedirect = () => {
    window.open('https://stan.store/maryambellakbira', '_blank');
  };

  return (
    <div className="bg-card p-8 md:p-12 rounded-3xl border border-border shadow-xl">
      <div className="flex items-center gap-3 mb-8">
        <div className="p-3 bg-primary/10 rounded-xl">
          <Icon name="MicrophoneIcon" size={28} className="text-primary" />
        </div>
        <div>
          <h2 className="text-3xl font-bold text-foreground">Speaking Engagement</h2>
          <p className="text-sm text-muted-foreground">Book Mary for your next event</p>
        </div>
      </div>

      <div className="space-y-6">
        <p className="text-muted-foreground text-lg">
          Interested in booking Mary for a keynote, panel, workshop, or other speaking engagement? Click below to submit your request and we'll get back to you within 2-3 business days.
        </p>

        <div className="bg-primary/5 p-6 rounded-xl space-y-3">
          <h3 className="font-semibold text-foreground flex items-center gap-2">
            <Icon name="CheckCircleIcon" size={20} className="text-primary" />
            Available Engagements:
          </h3>
          <ul className="space-y-2 text-muted-foreground ml-7">
            <li>• Keynote Speaker</li>
            <li>• Panelist</li>
            <li>• Workshop Speaker</li>
            <li>• Panel Moderator</li>
            <li>• Podcast Guest</li>
            <li>• Event Invitation</li>
          </ul>
        </div>

        <button
          onClick={handleRedirect}
          className="w-full px-8 py-4 bg-primary text-primary-foreground rounded-full font-bold text-sm uppercase tracking-wider hover:bg-primary/90 transition-all hover:scale-105 shadow-glow-teal inline-flex items-center justify-center gap-2"
        >
          <Icon name="CalendarIcon" size={20} />
          <span>Book Speaking Engagement</span>
          <Icon name="ArrowRightIcon" size={16} />
        </button>

        <p className="text-xs text-muted-foreground text-center">
          You'll be redirected to our booking platform to submit your request
        </p>
      </div>
    </div>
  );
}